import ConnectedContainer from "components/container/ConnectedContainer.tsx";
import {useAppSelector} from "config/store";
import {UserType} from "globals/types/models.ts";
import {tryAsyncFunc} from "globals/functions/async.ts";
import ajax from "config/ajax.ts";
import LoadingContainer from "components/container/LoadingContainer.tsx";
import {Form, Formik} from "formik";
import Input from "components/atom/Input.tsx";
import Button from "components/atom/button/Button.tsx";
import {useTranslation} from "react-i18next";
import {useState} from "react";

function MeContactUsPage() {
    const {t} = useTranslation()
    const currentUser: UserType | null = useAppSelector(state => state.auth.user)
    const [formSuccess, setFormSuccess] = useState<boolean>(false)

    const values = {
        subject: '',
        message: '',
    }

    if (!currentUser) {
        return null;
    }

    return (
        <ConnectedContainer title={t('menu.contactUs')}>
            <div className="mx-auto w-full md:max-w-[506px]">
                <Formik
                    initialValues={values}
                    validateOnChange={false}
                    validateOnBlur={false}
                    validate={values => {
                        const errors: Partial<{ [K in keyof typeof values]: string }> = {};//same keys as type but with string value
                        if (!values.subject) {
                            errors.subject = t('forms.errors.subject')
                        }
                        if (!values.message) {
                            errors.message = t('forms.errors.message')
                        }
                        return errors;
                    }}
                    onSubmit={async (values, {setSubmitting, setStatus, setFieldError, resetForm}) => {
                        setSubmitting(true);
                        setStatus(null);
                        setFormSuccess(false)

                        const [_, err] = await tryAsyncFunc(ajax.post('/connected/globals/contact-us', values))
                        setSubmitting(false);

                        if (err) {
                            const errData = err.response.data || {}
                            const errors = errData.errors || {}

                            if (errors.global) {
                                setStatus(errors.global)
                                delete errors.global
                            }

                            Object.keys(errors).forEach(errKey => {
                                setFieldError(errKey, errors[errKey])
                            })
                            return
                        }

                        setFormSuccess(true)
                        resetForm({
                            values: {
                                subject: '',
                                message: ''
                            }
                        })
                    }}
                >
                    {({isSubmitting, status}) => (
                        <LoadingContainer isLoading={isSubmitting} keepChildren>
                            <Form>

                                <Input name="subject" type="text"
                                       label={t('forms.subject')}/>

                                <Input name="message" type="textarea"
                                       label={t('forms.message')}/>


                                {status && (
                                    <p className="error block">{status}</p>
                                )}
                                {formSuccess && (
                                    <p className="text-green-700 block">{t('contact.youWillBeContactedSoon')}</p>
                                )}
                                <div className="mt-4 flex w-full flex-row items-center justify-center">
                                    <Button className="w-full" type="submit" disabled={isSubmitting}>
                                        {t('send')}
                                    </Button>
                                </div>
                            </Form>
                        </LoadingContainer>
                    )}
                </Formik>
            </div>
        </ConnectedContainer>

    )
}

export default MeContactUsPage
